import React, { useState, useEffect, useRef } from "react";

const BannerWordRotate = () => {
  const words = ["HEMEN", "KOLAY", "HIZLI", "GÜVENLİ"];
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null); // Kapsayıcı için referans
  const wordRef = useRef(null); // Aktif kelime için referans

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 3000); // Her 3 saniyede bir kelime değişir
    return () => clearInterval(interval);
  }, [words.length]);

  // Kapsayıcı boyutunu dinamik olarak ayarla
  useEffect(() => {
    if (containerRef.current && wordRef.current) {
      const { offsetWidth, offsetHeight } = wordRef.current;
      containerRef.current.style.width = `${offsetWidth}px`;
      containerRef.current.style.height = `${offsetHeight}px`;
    }
  }, [index]);
  return (
    <div className="bg-black text-white pt-32">
      <div className="container mx-auto text-center">
        <h2 className="text-xl sm:text-2xl font-medium mb-1">
          En iyi fiyat teklifimize iPhone cihazını
        </h2>
        <h1 className="text-4xl sm:text-5xl font-bold mb-6 flex justify-center items-center">
          {/* Dinamik Genişlik ve Yükseklik */}
          <div
            ref={containerRef}
            className="relative flex justify-center items-center "
          >
            {words.map((word, wordIndex) => (
              <span
                key={word}
                ref={wordIndex === index ? wordRef : null}
                className={`absolute transition-all duration-1000 ease-in-out  ${
                  wordIndex === index
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-[100%]"
                } bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500 text-transparent bg-clip-text leading-[1.2]`}
              >
                {word}
              </span>
            ))}
          </div>
          {/* Sabit "SAT" Kelimesi */}
          <span className="ml-4 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500 text-transparent bg-clip-text">
            SAT
          </span>
        </h1>
        <div className="flex justify-center">
          <img
            src="/home2banner.png"
            alt="iPhone cihazı"
            className="w-60 sm:w-72 lg:w-80 mx-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default BannerWordRotate;
